import React from 'react';
import Layout from '../components/layout/Layout';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import ActivityFeed from '../components/dashboard/ActivityFeed';

const Activity = () => {
  const { account } = useWallet();
  const user = useUserData();

  return (
    <Layout dashboard>
      <div className="page-header">
        <div className="page-title">Activity</div>
        <div className="page-subtitle">Last 100 events from the on-chain log.</div>
      </div>
      {!account || !user.userId ? (
        <div className="card" style={{ textAlign: 'center' }}>
          <div className="empty-title">Connect & register to view your activity</div>
        </div>
      ) : (
        <ActivityFeed activities={user.activities} />
      )}
    </Layout>
  );
};

export default Activity;
